import { useTranslation } from 'react-i18next';
import { AddressState, Country } from '@steelbuy/ts-shared';
import { CardContentAttributesItem } from '../card-content-attributes/card-content-attributes-item/CardContentAttributesItem';
import { CountryIcon } from '../country-icon/CountryIcon';

export const CardContentMaterialLocation = ({ countryCode, state }: { countryCode: Country; state?: AddressState }) => {
    const { t } = useTranslation(['uiPrimitive', 'domainModel']);

    const locations = [];

    if (state) locations.push(t(`domainModel:address.state.${state}`));
    locations.push(t(`domainModel:address.country.${countryCode}`));

    return (
        <CardContentAttributesItem label={t('checkout.delivery.materialLocationLabel')} value={locations.join(', ')}>
            <CountryIcon code={countryCode} />
        </CardContentAttributesItem>
    );
};
